<template>
  <div class="form-group"
       :class="[
       {'input-group': hasIcon},
       {'has-danger': error},
       {'input-group-focus': focused},
       {'has-label': label || $slots.label},
       {'has-success': !error && touched}]">
    <div v-show="false">{{isActive}}</div>

    <slot name="label">
      <label v-if="label" :class="labelClasses">
        {{label}}
        <span v-if="required">*</span>
      </label>
    </slot>
    <slot name="addonLeft">
      <div v-if="addonLeftIcon" class="input-group-addon input-group-prepend">
        <i :class="addonLeftIcon"></i>
      </div>
    </slot>
    <slot>
      <!--        v-mask="/[$][,\d]{0,100}.\d{0,2}/"-->
      <input
        ref="input"
        @keyup.enter="$emit('enter')"
        v-bind:value="value"
        v-on="listeners"
        v-bind="$attrs"
        :size="inputSize"
        @blur="isActive = false"
        @focus="isActive = true"
        class="form-control"
        v-bind:class="[{valid: value && !error}, inputClasses]"
        aria-describedby="addon-right addon-left">
    </slot>
    <slot name="addonRight">
        <span v-if="addonRightIcon" class="input-group-addon input-group-append">
          <i :class="addonRightIcon"></i>
        </span>
    </slot>

    <slot name="infoBlock"></slot>
    <slot name="helpBlock">
      <div class="text-danger invalid-feedback" style="display: block;" :class="{'mt-2': hasIcon}" v-if="error && typeof(error) != 'boolean'">
        {{ error }}
      </div>
    </slot>
  </div>
</template>
<script>
    import * as accounting from 'accounting-js'

    export default {
        inheritAttrs: false,
        name: 'currency-input',
        props: {
            editing: false,
            value: {
                type: [String, Number],
                default: 0
            },
            label: {
                type: String,
                default: ''
            },
            inputSize: {
                type: Number,
                default: 25,
            },
            required: Boolean,
            error: null,
            labelClasses: String,
            inputClasses: String,
            addonRightIcon: String,
            masking: RegExp,
            type: Number,
            addonLeftIcon: String
        },
        data() {
            return {
                touched: false,
                focused: false,
                isActive: false,
            }
        },

        async mounted() {
            await this.value;
            this.formatValue();
            /*if(this.editing){
              this.focused = true;
            }*/
        },
        updated() {
            this.formatValue();
        },
        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                    input: this.updateValue,
                    blur: this.blurEmitter
                }
            },
            hasIcon() {
                const {addonRight, addonLeft} = this.$slots
                return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
            }
        },

        methods: {
            blurEmitter() {
                this.$emit('blur', this.value)
            },
            updateValue: function () {
                this.touched = true;
                if (this.$refs.input.value === "" || this.$refs.input.value === "$") {
                    this.$emit('input', "")
                    this.$emit('keyup', "")
                } else if (this.$refs.input.value === ".") {
                  this.$emit('input', "0.");
                  this.$emit('keyup', "0.");
                } else {
                    let val = accounting.unformat(this.$refs.input.value)
                    this.$emit('input', val)
                    this.$emit('keyup', val)
                }
            },

            formatValue: function () {
                // Cursor is inside the input field. unformat display value for user
                if (this.isActive && this.value) {
                    return this.value.toString()
                } else if(this.value && this.$refs.input){
                    if (this.value === "") {
                        this.$refs.input.value = this.value
                    } else if (this.value % 1 === 0) {
                        this.$refs.input.value = accounting.formatMoney(accounting.unformat(this.value), {
                            format: "%s%v", // controls output: %s = symbol, %v = value/number (can be object: see below)
                            decimal: ".",  // decimal point separator
                            thousand: ",",  // thousands separator
                            precision: 0   // decimal places
                        });
                    } else if (this.value * 10 % 1 === 0) {
                        this.$refs.input.value = accounting.formatMoney(accounting.unformat(this.value), {
                            format: "%s%v", // controls output: %s = symbol, %v = value/number (can be object: see below)
                            decimal: ".",  // decimal point separator
                            thousand: ",",  // thousands separator
                            precision: 2   // decimal places
                        });
                    } else if (this.value * 100 % 1 === 0) {
                        this.$refs.input.value = accounting.formatMoney(accounting.unformat(this.value), {
                            format: "%s%v", // controls output: %s = symbol, %v = value/number (can be object: see below)
                            decimal: ".",  // decimal point separator
                            thousand: ",",  // thousands separator
                            precision: 2   // decimal places
                        });
                    } else if (this.value * 100 % 1 !== 0) {
                        this.$refs.input.value = accounting.formatMoney(accounting.unformat(this.value), {
                            format: "%s%v", // controls output: %s = symbol, %v = value/number (can be object: see below)
                            decimal: ".",  // decimal point separator
                            thousand: ",",  // thousands separator
                            precision: 2   // decimal places
                        });
                    }

                    this.focused = true;
                }
            }
        }
    }
</script>
<style>

</style>
